import {
  Edit,
  FormTab,
  NumberInput,
  SaveButton,
  TabbedForm,
  Toolbar,
  maxValue,
  minValue,
} from 'react-admin';
import { Tooltip } from '../components';
import Permission from '../components/Permission';
import { PERMISSIONS } from '../constants';

const SystemConfig = (props) => {

  const ToolbarListActions = () => (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  );

  return (
    <Permission permission={PERMISSIONS.EDIT_CHAIN_SYSTEM_DEFAULT_TAX}>
      <Edit
        id="1"
        title="Configurações"
        resource="system-config"
        mutationMode="pessimistic"
      >
        <TabbedForm toolbar={<ToolbarListActions />}>
          <FormTab label="Geral">
            <Permission permission={PERMISSIONS.EDIT_CHAIN_SYSTEM_DEFAULT_TAX}>
              <Tooltip sxContainer={{ alignItems: 'center' }} placement="top-start" title="Define a taxa padrão cobrada por transação, essa taxa é utilizada caso não haja uma taxa personalizada para a rede/transportadora.">
                <NumberInput
                  sx={{ width: 435 }}
                  label="Taxa padrão para as redes"
                  source="chainDefaultTax"
                  validate={minValue(0)}
                />
              </Tooltip>
            </Permission>
            <Tooltip sxContainer={{ alignItems: 'center' }} placement="top-start" title="Define o percentual máximo de desconto na taxa que usuários com permissão de Nível 1 podem aplicar nas redes.">
              <NumberInput
                sx={{ width: 435 }}
                label="Desconto percentual máximo para Nível 1"
                source="chainLevel1MaxTaxDiscount"
                validate={[minValue(0), maxValue(100)]}
              />
            </Tooltip>
            <Tooltip sxContainer={{ alignItems: 'center' }} placement="top-start" title="Define o percentual máximo de desconto na taxa que usuários com permissão de Nível 2 podem aplicar nas redes.">
              <NumberInput
                sx={{ width: 435 }}
                label="Desconto percentual máximo para Nível 2"
                source="chainLevel2MaxTaxDiscount"
                validate={[minValue(0), maxValue(100)]}
              />
            </Tooltip>
            <Tooltip sxContainer={{ alignItems: 'center' }} placement="top-start" title="Define o percentual máximo de desconto na taxa que usuários com permissão de Nível 3 podem aplicar nas redes.">
              <NumberInput
                sx={{ width: 435 }}
                label="Desconto percentual máximo para Nível 3"
                source="chainLevel3MaxTaxDiscount"
                validate={[minValue(0), maxValue(100)]}
              />
            </Tooltip>
          </FormTab>
        </TabbedForm>
      </Edit>
    </Permission>
  );
};

const resource = {
  edit: SystemConfig,
  list: SystemConfig,
  name: 'system-config',
  permissions: [PERMISSIONS.ADMIN]
};

export default resource;